import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top-button',
  templateUrl: './scroll-to-top-button.component.html',
  styleUrls: ['./scroll-to-top-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollToTopButtonComponent {
  @Output() buttonClicked = new EventEmitter<void>();
}
